import { apiClient } from "./client";

export async function listPins(serverId) {
  const res = await apiClient.post("/dash/pins/list", { id: serverId });
  return res.data;
}

export async function createPin(serverId, title, toolName, payload) {
  const res = await apiClient.post("/dash/pins/create", { id: serverId, title, toolName, payload });
  return res.data;
}

export async function removePin(pinId) {
  const res = await apiClient.post("/dash/pins/remove", { pinId });
  return res.data;
}
